module.exports = "/images/tv.svg?3df7c3e40f048004ac341cfeb85e6e23";